import React from 'react'
import classNames from 'classnames'

export default function MainContainer({
    children,
    large,
    small,
    fullWidth,
    sidebar = false,
    className = ""
}) {

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "box-border w-full mx-auto": true,
        "max-w-800": small && !fullWidth,
        "max-w-1000": !large && !small && !fullWidth,
        "max-w-1200": large && !fullWidth,
        "px-5 md:px-8": !sidebar,
        "px-5 md:px-10 max-w-1000 mx-auto": sidebar,
        ...classes
    })

    return (
        <div className={Classes}>
            {children}
        </div>
    )
}
